


















import Vue from 'vue';
import BaseInformationBlock from './base-information-block.vue';

export default Vue.extend({
  name: 'IssueInformationBlock',
  props: {
    subTitle: {
      type: String,
      default: 'Budget for day 3 is $25 above, Issue reason 2, Issue reason 3',
    },
    title: {
      type: String,
      default: 'There are 3 issues meeting your Itinerary Constraints',
    },
  },
  components: {
    BaseInformationBlock,
  },

  computed: {},
  methods: {},
});
